var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9C\xD0\xB0\xD0\xBB\xD0\xB5\xD0\xBD\xD1\x8C\xD0\xBA\xD0\xB8\xD0\xB5 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 / \xD0\x9F\xD0\xBB\xD0\xB0\xD1\x82\xD0\xB5\xD0\xB6\xD0\xB8 \xD0\xB2 \xD0\xB2\xD0\xB0\xD0\xBB\xD1\x8E\xD1\x82\xD0\xB5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7917 15.9997H22.4583M3.79167 7.99967H6.45833M1.125 5.33301H25.125V18.6663H1.125V5.33301ZM17.125 11.9997C17.125 14.2088 15.3341 15.9997 13.125 15.9997C10.9159 15.9997 9.125 14.2088 9.125 11.9997C9.125 9.79054 10.9159 7.99967 13.125 7.99967C15.3341 7.99967 17.125 9.79054 17.125 11.9997Z",
    stroke: "#AAACAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.fe254dd77db449d4d19d8d3f16f502a1.svg";
export { ForwardRef as ReactComponent };